import type { TagCloneRequest, TagCreateRequest, TagUpdateRequest } from '@arhs-fleetback/types/entities/tags';

import { PROJECTION, SEARCH_PROXY, TAGS_API_URL } from 'constants/ApiConstants';
import { PaginationType } from 'constants/Global';
import * as types from 'modules/tags/actionTypes';

import type { CreateTagAction, DeleteTagAction, DeleteTagSuccessAction, DuplicateTagAction, FetchTagAction, FetchTagsAction, FetchTagsParams, UpdateTagAction } from '../types';

export const fetchTags = (params: FetchTagsParams = {}, meta = {}): FetchTagsAction => {
  const { proxy = SEARCH_PROXY.ALTERABLE, ...restParams } = params;

  return {
    type: types.FETCH_TAGS,
    payload: {
      request: {
        method: 'GET',
        url: `${TAGS_API_URL}/search/${proxy}`,
        params: {
          /* Default pagination params */
          page: 0,
          size: 10,
          sort: 'name,ASC',
          projection: PROJECTION.PAGE,
          paginationType: PaginationType.SLICE,
          /* Custom params (filters) */
          ...restParams
        }
      }
    },
    meta: {
      '@app-request': true,
      ...meta
    }
  };
};

export const fetchTag = (tagId: string, meta = {}): FetchTagAction => ({
  type: types.FETCH_TAG,
  payload: {
    request: {
      method: 'GET',
      url: `${TAGS_API_URL}/${tagId}`
    }
  },
  meta: {
    '@app-request': true,
    ...meta
  }
});

export const createTag = (data: TagCreateRequest, meta = {}): CreateTagAction => ({
  type: types.CREATE_TAG,
  payload: {
    request: {
      method: 'POST',
      url: TAGS_API_URL,
      data
    }
  },
  meta
});

export const updateTag = (data: TagUpdateRequest & { id: string }, meta = {}): UpdateTagAction => ({
  type: types.UPDATE_TAG,
  payload: {
    request: {
      method: 'PUT',
      url: `${TAGS_API_URL}/${data.id}`,
      data
    }
  },
  meta
});

export const deleteTag = (tagId: string, meta = {}): DeleteTagAction => ({
  type: types.DELETE_TAG,
  payload: {
    request: {
      method: 'DELETE',
      url: `${TAGS_API_URL}/${tagId}`
    },
    tagId
  },
  meta
});

export const deleteTagSuccess = (tagId: string, meta = {}): DeleteTagSuccessAction => ({
  type: types.DELETE_TAG_SUCCESS,
  payload: tagId,
  meta
});

export const duplicateTag = (tagId: string, data: TagCloneRequest, meta = {}): DuplicateTagAction => ({
  type: types.CLONE_TAG,
  payload: {
    request: {
      method: 'POST',
      url: `${TAGS_API_URL}/${tagId}/clone`,
      data
    },
    tagId
  },
  meta
});
